"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyFab = void 0;

const react_1 = __importDefault(require("react"));

const material_1 = require("@mui/material");

const StyledFab = (0, material_1.styled)(material_1.Fab)(({
  theme
}) => ({
  margin: theme.spacing(1),
  borderRadius: "50%",
  width: 40,
  height: 40
}));

const SskyFab = props => {
  return react_1.default.createElement(StyledFab, {
    id: props.id,
    className: props.className,
    variant: props.variant,
    color: props.color,
    disabled: props.disabled,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    "data-testid": props.dataTestId || `testId-${props.id || props.label}`
  }, props.label, props.icon);
};

exports.SskyFab = SskyFab;
SskyFab.defaultProps = {
  color: "primary",
  variant: "round"
};
exports.default = react_1.default.memo(SskyFab);